import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppServerAPI } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/common';
import { Station, SaveMapConfiguration, SaveMapConfigurationResponse, MapConfiguration } from './yard-map-configuration-model';

@Injectable({
  providedIn: 'root'
})
export class YardMapConfigurationService {

  constructor(private appServerAPI: AppServerAPI) {
  }

  public loadMapConfigurations(): Observable<Array<MapConfiguration>> {
    return this.appServerAPI.execute<Array<MapConfiguration>>('/client/admin/yardmap/configurations', {});
  }

  public getStations(): Observable<Array<Station>> {
    return this.appServerAPI.execute<Array<Station>>('/client/admin/yardmap/stations', {});
  }

  public loadMapConfiguration(configurationId: number): Observable<any> {
    return this.appServerAPI.execute<any>('/client/admin/yardmap/details', configurationId);
  }

  public deleteMapConfiguration(configurationId: number): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/client/admin/yardmap/delete', configurationId);
  }

  public saveMapConfiguration(request: SaveMapConfiguration): Observable<SaveMapConfigurationResponse> {
    return this.appServerAPI.execute<SaveMapConfigurationResponse>('/client/admin/yardmap/save', request);
  }

}
